import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '@/components/react/form/hooks/form';
import { ErrorMessage } from '@/components/react/form/elements/ErrorMessage';
import { AnimatedPlaceholder } from '@/components/react/form/elements/AnimatedPlaceholder';
import { cn } from '@/lib/utils';
import PhoneInput from 'react-phone-number-input/input';

interface TextInputProps {
  label: string;
  type?: 'text' | 'tel';
}

export const PhoneNumberInput = ({ label }: TextInputProps) => {
  const { state, handleChange, handleBlur, store } = useFieldContext<
    (string & { __tag: 'E164Number' }) | undefined
  >();
  const { errors } = useStore(store, ({ meta }) => meta);

  return (
    <div className="relative flex h-20 w-full flex-col gap-1 @sm:basis-1/2">
      <div className="relative">
        <PhoneInput
          aria-invalid={errors.length > 0}
          data-required="true"
          aria-required="true"
          className={cn(
            'selection:bg-brand-purple-black peer border-brand-medium-gray text-brand-purple-black focus-visible:border-brand-purple-bright focus-visible:ring-brand-focus flex h-11 w-full min-w-0 rounded-sm border bg-transparent px-4 py-2.5 text-base font-medium transition-[color,box-shadow] outline-none selection:text-white placeholder:h-0 focus-visible:ring-2 disabled:pointer-events-none disabled:cursor-not-allowed',
            {
              'border-brand-error': errors.length > 0,
            },
          )}
          id="phone"
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder={label}
          value={state.value}
        />
        <AnimatedPlaceholder placeholder={label} />
      </div>
      <ErrorMessage />
    </div>
  );
};
